import { NavItem } from '../../shared/models/nav-item.model';

export const NAV_ITEMS: NavItem[] = [
  { label: 'Overview', route: '/overview', icon: 'layout-dashboard', enabled: false },
  { label: 'Users', route: '/users', icon: 'users', enabled: false },
  { label: 'Command Center', route: '/command-center', icon: 'radio', enabled: false },
  { label: 'Bus Management', route: '/bus-management', icon: 'bus', enabled: true },
  { label: 'Fleet Management', route: '/fleet-management', icon: 'truck', enabled: false },
  { label: 'Transactions', route: '/transactions', icon: 'banknote', enabled: false },
  { label: 'CMS', route: '/cms', icon: 'file-text', enabled: false },
  {
    label: 'Articles & Notifications',
    route: '/articles',
    icon: 'newspaper',
    enabled: false,
  },
  { label: 'Settings', route: '/settings', icon: 'settings', enabled: true },
  {
    label: 'Competitor Report',
    route: '/competitor-report',
    icon: 'bar-chart-3',
    enabled: false,
    emphasized: true,
  },
];
